import React from 'react';
import './FilterBarAndCards.css';

const FilterBarAndCards = ({ filterData, cardData, setFilter }) => {
    return (
        <div className="o-module__body">
            {/* Filter Bar */}
            <div className="c-filterbar" data-filter-parent-id="">
                <span id="VerbandsmitgliedschaftenKategorie" hidden>
                    Kategorie der weltweiten Verbandsmitgliedschaften
                </span>
                <ul className="o-interaction-button-group" aria-labelledby="VerbandsmitgliedschaftenKategorie">
                    {filterData.map((filter, index) => (
                        <li key={index} className="o-interaction-button-group__item">
                            <button
                                className={`c-interaction-button ${filter.isSelected ? 'is-selected' : ''}`}
                                id={`cardFilter-${index}`}
                                type="button"
                                onClick={() => setFilter(filter.value)}
                            >
                                <span className="c-interaction-button__label">{filter.label}</span>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>

            {/* Card Rack */}
            <div className="o-card-rack">
                <div className="o-card-rack__body">
                    {cardData.map((card, index) => (
                        <div key={index} className="o-card-rack__item" data-parent={card.parent}>
                            <div className="c-card has-truncated-text">
                                <div className="c-card__body">
                                    <h3 className="c-card__title">
                                        <a href={card.link} target="_blank" rel="noreferrer">
                                            {card.title}
                                        </a>
                                    </h3>
                                    <p className="c-card__text">{card.description}</p>
                                    <div><span className="c-tag">{card.tag}</span></div>
                                </div>
                                <footer className="c-card__footer">
                                    <div className="c-card__footer__item">
                                        <a href={card.link} target="_blank" rel="noreferrer" className="c-link">
                                            <span className="c-link__label">Learn more</span>
                                            <i className="c-link__icon c--icon c-icon--system-arrow-right">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#D7102E" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                                </svg>
                                            </i>
                                        </a>
                                    </div>
                                </footer>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FilterBarAndCards;